module.exports = __webpack_public_path__ + "img/Weapon_120.90401596.png";